import connectHierarchicalMenu from "instantsearch.js/es/connectors/hierarchical-menu/connectHierarchicalMenu.js";
import { useConnector } from "../hooks/useConnector.js";
export function useHierarchicalMenu(props, additionalWidgetProperties) {
  return useConnector(connectHierarchicalMenu, props, additionalWidgetProperties);
}